<template>
  <div class="footer">
    <el-container>
      <el-footer>
        <div style="max-width: 100%; margin: 0 auto; background-color: #3d3d3d;">
          <div class="content">
            <div>
              学院地址：海南省海口市龙华区南海大道95号 网站备案号：琼ICP备11000397号 邮政编码:570216 招生电话：0898-31930666 31930777 31930888
            </div>
            <div>
              继续教育招生电话：0898-31930688 31930686 技术支持：资源信息中心
            </div>
            <div class="demo-fit">
              <div v-for="fit in fitsItems" :key="fit" class="block">
                <div>
                  <el-avatar v-if="!fit.width" shape="square" :size="124" fit="fit" :src="fit.url" />
                  <el-avatar v-else shape="square" :style="{width:fit.width, height: fit.height}" fit="fit" :src="fit.url" />
                </div>
                <div class="title">
                  <span class="title">{{ fit.name }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-footer>
    </el-container>
  </div>
</template>


<script>
export default {
  name: 'footerIndex',
  components: {
  },
  props: {
  },
  setup(){
    return {
    }
  },
  data(){
    return {
      fitsItems:[{
        'name': '海南职业技术学院官微',
        'url': 'http://www.hcvt.cn/statics/images/hcvt/weixin.jpg'
      },{
        'name': '海南职业技术学院抖音',
        'url': 'http://www.hcvt.cn/statics/images/hcvt/douyin.png'
      },{
        'name': '海南职业技术学院官博',
        'url': 'http://www.hcvt.cn/statics/images/hcvt/guanbo.jpg'
      },{
        'name': '',
        'url': 'http://www.hcvt.cn/statics/images/hcvt/blue.png',
        'width': '80px',
        'height': '80px'
      }]
    }
  },
  mounted(){
    // 添加窗口大小变化的事件监听器
    window.addEventListener('resize', this.checkScreenSize);
    // 初始化时检查屏幕大小
    this.checkScreenSize();
  },
  methods:{
    checkScreenSize() {
      // 使用媒体查询判断屏幕大小
      this.isH5 = this.$utils.checkScreenSize();
    }
  },
  beforeUnmount() {
    // 在组件销毁前移除事件监听器
    window.removeEventListener('resize', this.checkScreenSize);
  }
}
</script>

<style scoped>
.footer{
  background-color: #3d3d3d;
  height: 240px;
}

.footer .content{
  background-color: #3d3d3d;
  max-width: 80%; /* 设置内容区域最大宽度 */
  margin: 0 auto; /* 自动左右边距实现居中 */
  padding: 20px 0;
  border-top: 1px solid #515151;
  color: #707070;
  font-size: 12px;
  line-height: 22px;
  text-align: center;
}

.el-main {
  --el-main-padding: 0px;
}

.el-menu{
  background-color: #3d3d3d;
  color: white;
}

.el-menu-demo .el-menu-item{
  color: white;
  background-color: #3d3d3d!important;
}

.el-menu-demo .el-menu-item:hover{
  color: rgb(255, 255, 255);
  background-color: #3d3d3d!important;
}

.el-menu-demo .el-submenu__title{
  color: white;
  background-color: #3d3d3d!important;
}

.el-menu-demo .el-submenu__title:hover{
  color: white;
  background-color: #3d3d3d!important;
}

.el-menu--horizontal>.el-menu-item.is-active{
  border-bottom: 2px solid white;
  background-color: #3d3d3d;
  color: white !important;
}

.el-menu--horizontal.el-menu {
    border-bottom: solid 0px var(--el-menu-border-color);
}

.el-menu--horizontal>.el-menu-item{
  color: white !important
}

.el-menu--horizontal>.el-menu-item:hover{
  border-bottom: 2px solid white;
  color: white !important
}


.demo-fit {
  display: flex; 
  align-items: center; 
  justify-content: center;
}

.demo-fit .block{
  width: 150px;
  text-align: center;
}

.demo-fit .title {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  color: var(--el-text-color-secondary);
}

.demo-fit .el-avatar {
  background: unset;
}
</style>
